import { APIComponentAttributes, ArdoqId } from '@ardoq/api-types';
import { Locale } from '@ardoq/locale';
import { ContextSort } from '@ardoq/data-model';

export enum SortAttribute {
  ORDER = '_order',
  NAME = 'name',
  SOURCE = 'source',
  TARGET = 'target',
  TYPE = 'type',
}

export type ComponentByIdSortDependencies = {
  sort: ContextSort;
  componentAttributesById: Record<string, APIComponentAttributes>;
  isDateRangeField: boolean;
  userLocale: Locale;
  /**
   * Optional. When supplied AND `sort.attr === SortAttribute.ORDER`,
   * `compareComponentsById` uses this map instead of comparing raw `_order`
   * values. The map encodes a depth-first walk of the underlying component
   * tree where each level is sorted by `_order` — so two components in
   * different parents both with `_order=0` get distinct global indices that
   * mirror what the navigator menu renders. Callers that don't compute this
   * fall back to flat `_order` comparison (current behaviour).
   */
  treeOrderIndex?: ReadonlyMap<ArdoqId, number>;
};
